var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"btn",attrs:{"slot":"trigger","size":"mini","plain":"","type":"primary"},on:{"click":_vm.pickMaterial},slot:"trigger"},[_vm._v(" 素材库 "),_c('MaterialPickModal',{attrs:{"materialType":_vm.materialType,"show":_vm.show},on:{"onConfirmPickMaterial":_vm.onConfirmPickMaterial}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }